export default "__VITE_ASSET__DiGJOmqm__"